import { Phone, ArrowRight, ShieldCheck, MapPin } from "lucide-react";
import { COMPANY } from "@/data";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/84cb96e8-d8b9-48e9-a45f-1065ec73a096/images/a444814d9a37a89d28f0595a10594c066d55219197a7d1c0d172a3b189b400ce.png";

export const Hero = () => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20" data-testid="hero-section">
      <div className="absolute inset-0">
        <img src={HERO_BG} alt="Elektryk NDNS Elektro podczas montażu rozdzielnicy elektrycznej w Katowicach" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-deep via-navy-deep/80 to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-28 w-full">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 border border-magenta/50 bg-magenta/15 px-4 py-2 mb-8 reveal in-view">
            <ShieldCheck className="w-4 h-4 text-magenta-light" />
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-magenta-light">
              Uprawnienia SEP · Katowice
            </span>
          </div>

          <h1 className="font-heading font-black text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            Profesjonalne{" "}
            <span className="text-magenta-light">instalacje elektryczne</span> i systemy bezpieczeństwa
          </h1>

          <p className="mt-7 text-base sm:text-lg text-zinc-300 leading-relaxed max-w-2xl">
            NDNS Elektro to licencjonowany partner w zakresie nowoczesnych instalacji budowlanych
            i przemysłowych, sieci słaboprądowych, monitoringu CCTV oraz pomiarów SEP. Działamy
            w Katowicach, na całym Górnym Śląsku i w Małopolsce.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href={COMPANY.phoneHref}
              data-testid="hero-cta-call"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 text-sm font-bold text-white bg-magenta hover:bg-magenta-light transition-colors"
            >
              <Phone className="w-4 h-4" strokeWidth={2.5} /> Zadzwoń: {COMPANY.phone}
            </a>
            <a
              href="#uslugi"
              data-testid="hero-cta-services"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 text-sm font-bold text-white border-2 border-white/30 hover:border-magenta-light hover:text-magenta-light transition-colors"
            >
              Zobacz usługi <ArrowRight className="w-4 h-4" />
            </a>
          </div>

          <div className="mt-14 flex items-center gap-2 text-zinc-400 text-sm">
            <MapPin className="w-4 h-4 text-magenta-light" />
            {COMPANY.areas.join(" · ")}
          </div>
        </div>
      </div>
    </section>
  );
};
